import { ImageOrigin } from '@/helpers/image-url'

export function getImageOrigin(imageSrc: string): ImageOrigin {
  const normalizedImageSrc = imageSrc.split('?')[0].toLowerCase()

  if (normalizedImageSrc.includes('/-/media/')) {
    return ImageOrigin.CMSSitecore
  }

  return ImageOrigin.MediaServer
}
